var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"faq",attrs:{"id":"faq"}},[_c('div',{staticClass:"faq-container"},[_c('h2',{staticClass:"faq-title"},[_vm._v("Вопросы и ответы")]),_c('div',{staticClass:"faq-questions-container"},_vm._l((_vm.questions),function(question,i){return _c('FaqQuestion',{key:i,attrs:{"title":question.title,"text":question.text}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }